/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { useState, useRef, useEffect } from 'react';
import { faTruckFast } from '@fortawesome/free-solid-svg-icons';
import { Card, Form, FormControl, InputGroup, Collapse } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import PaymentPinModal from 'views/payment/quick-payment/PaymentPinModal';
import gsap from 'gsap';

// import PaymentPinModal from './PaymentPinModal';

const validationSchema = Yup.object().shape({
  amount: Yup.number()
    .min(1, 'Amount must be greater than 0')
    .max(3000, 'Amount must be less than 3000')
    .required('Amount is required')
    .test('decimal-places', 'Amount must have up to 2 decimal places', value =>
      /^\d+(\.\d{1,2})?$/.test(value)
    )
});
const CoalChallanPayment = ({
  defaultData = {},
  minWidth = '300px',
  hideNumber = false
}) => {
  const [selectedDriver, setSelectedDriver] = useState('');
  const [showDriver, setShowDriver] = useState(false);
  const [truckNumber, setTruckNumber] = useState('');
  const [showPin, setShowPin] = useState('');
  const amtRef = useRef('');

  const buttonRef = useRef(null);

  useEffect(() => {
    if (Object.keys(defaultData || {}).length > 0) {
      setShowDriver(true);
      setTruckNumber(defaultData.vehicle_number?.value);
    }
  }, [defaultData]);

  const { values, handleChange, handleBlur, errors, touched } = useFormik({
    initialValues: {
      amount: '',
      upi: ''
    },
    validationSchema: validationSchema,
    validateOnMount: true,
    onSubmit: values => {
      console.log('Form submitted with values:', values);
    }
  });

  const verifyUpi = () => {
    const tl = gsap.timeline();
    const button = buttonRef.current;
    // const textVerify = button.querySelector('.textVerify');
    // const textScanQr = button.querySelector('.textScanQr');

    tl.fromTo(
      '.textVerify',
      { top: '0px' },
      { top: '-30px', duration: 0.5, display: 'none' }
    );
    tl.fromTo(
      '.textScanQr',
      { bottom: '30px' },
      { duration: 0.5, bottom: '0px', display: 'inline' },
      '-=0.5'
    );
  };

  const verifyTruck = () => {
    setShowDriver(true);
    amtRef?.current?.focus();
  };

  useEffect(() => {
    if (showDriver) {
      setTimeout(() => {
        amtRef?.current?.focus();
      }, 500);
    }
  }, [showDriver]);

  useEffect(() => {
    if (selectedDriver) {
      setShowDriver(true);
    }
  }, [selectedDriver]);
  return (
    <>
      <Card style={{ minWidth: minWidth }}>
        {!hideNumber ? (
          <Card.Header className="bg-100 pt-3 pb-3 d-flex justify-content-center border-bottom-0">
            <h4
              className="mb-0 text-center border-bottom border-2 border-dark"
              style={{ width: 'max-content' }}
            >
              <span>Quick Payment</span>
              <FontAwesomeIcon
                icon={faTruckFast}
                className="ms-1"
                style={{ marginBottom: '-2px' }}
              />{' '}
            </h4>
          </Card.Header>
        ) : null}
        <Card.Body className={`${hideNumber ? 'p-2' : ''}`}>
          {!hideNumber ? (
            <div className="mb-2">
              <p className="mb-0 fs-9  text-600">Truck Number :</p>
              <Form.Group className="w-100">
                <InputGroup className="">
                  <FormControl
                    value={truckNumber}
                    onChange={e => setTruckNumber(e.target.value)}
                    placeholder="Enter Truck Number"
                    aria-label="voucher"
                  />
                  <Button
                    variant="phoenix-primary"
                    onClick={verifyTruck}
                    className="px-5"
                  >
                    Verify
                  </Button>
                </InputGroup>
              </Form.Group>
            </div>
          ) : null}
          {/* Fct> */}
          <Collapse in={showDriver}>
            <div className="mb-3">
              <div className=" mb-2">
                <p className="mb-1 fs-9 text-600">Assigned Driver Name :</p>
                <Form.Group>
                  <Form.Control
                    disabled
                    className="w-100"
                    type="text"
                    value={defaultData?.driver_name?.value || 'Sanjay Yadaw'}
                  ></Form.Control>
                </Form.Group>
              </div>
              <div className="mb-2">
                <p className="mb-1 fs-9  text-600">Driver Mobile No :</p>
                <Form.Group>
                  <Form.Control
                    fullwidth
                    disabled
                    type="text"
                    value={defaultData?.driver_mobile?.value || '6203664800'}
                  ></Form.Control>
                </Form.Group>
              </div>
              <div className="">
                <p className="mb-1 fs-9  text-600">Driver UPI Id :</p>
                <Form.Group className="w-100" controlId="upi">
                  <InputGroup className="">
                    <FormControl
                      name="upi"
                      value={values.upi}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter UPI Number"
                      aria-label="voucher"
                    />
                    <Button
                      variant="phoenix-primary"
                      onClick={verifyUpi}
                      className="px-5 position-relative overflow-hidden"
                      ref={buttonRef}
                    >
                      <span className="textVerify position-relative">
                        Verify
                      </span>
                      <span
                        className="textScanQr position-relative"
                        style={{ display: 'none' }}
                      >
                        Scan Qr
                      </span>
                    </Button>
                  </InputGroup>
                </Form.Group>
              </div>
              <div
                className={` border-bottom border-dashed py-3 pt-2 mb-4 ${
                  hideNumber ? 'pb-4' : ''
                }`}
              >
                <p className="mb-1 fs-9  text-600">Amount to pay :</p>
                <InputGroup className="">
                  <FormControl
                    placeholder="Amount"
                    aria-label="Amount"
                    type="number"
                    ref={amtRef}
                    name="amount"
                    value={values.amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </InputGroup>
                {errors.amount && touched.amount && (
                  <div className="invalid-feedback">{errors.amount}</div>
                )}
              </div>
            </div>
          </Collapse>

          <Button
            className="w-100"
            disabled={errors.amount}
            variant="primary"
            onClick={() => setShowPin(true)}
            endIcon={
              <FontAwesomeIcon icon={faChevronRight} className="ms-1 fs-10" />
            }
          >
            Proceed to pay
          </Button>
        </Card.Body>
      </Card>
      <PaymentPinModal show={showPin} handleClose={() => setShowPin(false)} />
    </>
  );
};

export default CoalChallanPayment;
